import { render } from "./DeckHandler.vue?vue&type=template&id=d353c2fe&scoped=true"
import script from "./DeckHandler.vue?vue&type=script&lang=js"
export * from "./DeckHandler.vue?vue&type=script&lang=js"

import "./DeckHandler.vue?vue&type=style&index=0&id=d353c2fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d353c2fe"]])

export default __exports__